import SvgIcon from "../../utils/Icon";
import { ReactComponent as BeneficiosIcon } from "../../assets/icons/beneficios.svg";

const Beneficios = () => (
    <div className="mx-4">
        <div className="mb-4">
            <h2 className="text-2xl font-bold text-gray-800 flex items-center">
                <div className="bg-gradient-to-r from-[#f79865ff] to-[#ffaa6b] p-3 rounded-xl mr-4 shadow-md">
                    <SvgIcon Icon={BeneficiosIcon} className="w-6 h-6 text-white" />
                </div>
                Beneficios para ti
            </h2>
        </div>
        <div className="bg-white rounded-2xl shadow-md p-6 border border-gray-200">
            <p className="text-gray-700 leading-relaxed">
                Por ser parte de REDPLIKA, accede a condiciones especiales, descuentos, tarifas preferenciales y otras oportunidades ofrecidas por nuestra red de aliados.
            </p>
            <a
                href="#aliados-estrategicos"
                className="inline-block mt-4 text-[#1f94c2] font-semibold hover:underline"
            >
                Explora los aliados disponibles y descubre los beneficios que tenemos para ti →
            </a>
        </div>
    </div>
);

export default Beneficios;
